import SentBubble from '../sent-bubble/sent-bubble';
import GamgeeMessage from '../gamgee-message/gamgee-message';
import StreamingMessage from '../streaming-message/streaming-message';
import RichGamgeeMessage from '../rich-gamgee-message/rich-gamgee-message';
import AssetMessage from '../asset-message/asset-message';
import { GamgeeChatMessageRead } from '~/types/message';

export default function Message({ message, scrollToBottom }: { message: GamgeeChatMessageRead, scrollToBottom: () => void }) {
  if (message.message.message_type === 'streaming') {
    return <StreamingMessage message={message} scrollToBottom={scrollToBottom} />;
  }
  if (message.message.message_type === 'text') {
    if (message.message.sender === 'gamgee') {
      return <GamgeeMessage message={message} />;
    }
    return <SentBubble message={message} />;
  }
  if (message.message.message_type === 'rich') {
    return <RichGamgeeMessage message={message} scrollToBottom={scrollToBottom} />;
  }
  if (message.message.message_type === 'asset_message') {
    return <AssetMessage message={message} />;
  }
  return <div>Unknown message type</div>;
}
